
const initState = {
    UserList:[],
    productList:[],
    status:'init',
    message: null
}

export default function UserReducer (preState=initState,action){
    switch (action.type) {
        case 'GET_USER_SUCCESS':
            return {
                ...preState,
                UserList:action.payload,
                status:'success',
                message: 'Successfully fetched'
            }
        case 'GET_PRODUCT_SUCCESS':
            return {
                ...preState,
                productList:action.payload,
                status:'success',
                message: 'Successfully fetched'
            }
        case 'USER_FAIL':
            return {
                ...preState,
                status:'error',
                message:action.payload
            }
        default:
            return preState
    }
}